import type { JSX } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';

import { VisuallyHidden } from '../../../core/components/visually-hidden/VisuallyHidden.js';

/**
 * Renders a visually-hidden accessible name for built-in columns that have no visible header text.
 * @internal
 */
export function BuiltinColumnHeaderName({
  message,
}: {
  readonly message: MessageDescriptor;
}): JSX.Element {
  const intl = useIntl();
  return <VisuallyHidden>{intl.formatMessage(message)}</VisuallyHidden>;
}
